function Title() {
    return <div style={ { textAlign: "center", marginBottom: "16px"}}>
        <h1>Crowdsale</h1>
        <h2 >Clube do Blockchain<br /> <span style={{ color: "red" }} > (Demo)</span></h2>
        </div>;
}

export default Title;
